import React, { useContext, useEffect } from 'react'
import {
    Route,
    BrowserRouter as Router,
    withRouter,
    Switch,
} from 'react-router-dom'
import PrivateRoute from './privateRoute'
import Dashboard from '../views/Dashboard'
import Profile from '../product/customViews/Profile'

import AuctionLots from '../views/AuctionLots/dynamic'
import Report from '../views/Report'
import Listing from '../views/Listing/dynamic'
import BidDeposit from '../product/customViews/BidDeposit'
import UserView from '../product/customViews/UserManagement/dynamic'
import Employee from '../views/EmployeeManagement'
import TemplateView from '../product/views/Communications/TemplateView'
import StaticView from '../product/customViews/Settings/StaticView'
import BroadCaster from '../product/customViews/VideoAuction/BroadCaster'
import Return from '../product/customViews/Return'
import ReturnView from '../product/customViews/Return/view'
import Inventory from '../product/customViews/Inventory'
import QuestionAnswer from '../product/customViews/Comments/index'
import EmailLogs from '../product/views/Communications/EmailLogs'
import Invoice from '../views/Invoice'
import Payment from '../product/customViews/Payment'
import LanguageManager from '@/views/LanguageManager'
import StaticPages from '../product/customViews/Settings/StaticPages'
import ConfigView from '../product/customViews/Settings/ConfigView'
import MaintanenceManage from '../product/views/Settings/Maintanence/MaintanenceManage'
import ChangePassword from '@/product/views/ChangePassword'
import AuthContext from '@/product/context/auth/authContext'
import CustomCommonContext from '../custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import Category from '../product/customViews/Settings/Category'
import Condition from '../views/Settings/Condition'
import Location from '../product/customViews/Settings/Location'
import OrgView from '../product/customViews/Organization/OrgView'
import CreateCampaign from '../product/customViews/Campaign/CreateCampaign'
import EmailTemplate from '../product/customViews/Campaign/EmailTemplate'
import Wallet from '../product/customViews/Wallet'
import SubscribeData from '../product/customViews/subscribe'
import TransactionPayment from '../product/customViews/Transaction/payment'
import TransactionRefund from '../product/customViews/Transaction/refund'
import Appointment from '../product/customViews/Appointment'
import BidIncrement from '../product/customViews/Settings/BidIncrement'
import LiveAuction from '../product/customViews/VideoAuction/LiveAuction'
import SettingsUI from '../product/customViews/SettingsUI'
import DynamicPage from '../product/customViews/Dynamic/pages'
import CustomerActivity from '../product/customViews/CustomerActivity'
import TaxCodeList from '../product/customViews/Settings/TaxCodeList'
import DynamicTablePages from '@/product/views/DynamicTable/pages'
import Message from '../product/customViews/Message'
import Order from '../product/customViews/Order'
import ERP from '../product/customViews/ERP'
import Plugins from '@/product/views/Plugins'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import PalletPricing from '../product/customViews/Settings/PalletPricing'
// import MyCard from '../product/customViews/MyPayments/MyCards'
import AuctionTemplates from '../product/customViews/Template/Auction/dynamic'
import ProductTemplates from '../product/customViews/Template/Product/dynamic'
import BannerImage from '../views/Settings/BannerImage'
import TwoFactor from '../product/customViews/Settings/TwoFactor'
import BillingInfo from '../product/views/MyPayments'
import MyInvoice from '../product/views/MyInvoice'
import EditListing from '@/custom/components/organisms/Customized/Listing/Tabs/EditListing'
import InvoiceView from '../views/Invoice/view'
import ProductTemplateManage from '../product/customViews/Template/Product/dynamicListing'
import Logs from '../product/customViews/Logs'
import ManageComments from '../product/customViews/Comments/manageComments'
import EmployeeView from '../product/customViews/EmployeeManagement/edit'
import AuctionTemplateManage from '../product/customViews/Template/Auction/dynamicListing'
import EmployeeEdit from '../views/EmployeeManagement/edit'
import SellerEdit from '../views/EmployeeSellerManagement/edit'
import EmployeeManage from '../views/EmployeeManagement/view'
import EmployeeSellerManage from '../views/EmployeeSellerManagement/view'
import EmployeeSeller from '../views/EmployeeSellerManagement'
import OrgManage from '../product/customViews/Organization/OrgManage'
import UserManage from '../views/UserManagement/dynamicUser'
// import InitialFunction from '@/product/views/InitialFunction'
import AuctionListing from '../product/customViews/AuctionLots/dynamicListing'
import Theme from '../product/customViews/Store/Theme'
import ListingManage from '../views/Listing/dynamicListing'
import AgencyView from '@/product/customViews/AgencyManagement'
import AllAgencyUsers from '@/product/customViews/AgencyManagement/AgencyUsers'
import AgencyPayment from '@/product/customViews/AgencyManagement/payment'
import Login from '@/views/Login'
import InitialPublicFunction from '@/product/views/InitialFunction/public'
import UserReview from '../views/Review'
import CategorySelect from '@/views/Settings/Category'

const Routes = () => {
    const { loadUser } = useContext(AuthContext)
    const { getAllCountries, getAllStates } = useContext(ProductCommonContext)
    const { getGlobalVariable } = useContext(CustomCommonContext)
    const { getAllDynamicFields, getAllDynamicTables } =
        useContext(DynamicContext)

    useEffect(() => {
        if (localStorage.token) {
            loadUser()
        }
    }, [])

    return (
        <>
            <InitialPublicFunction
                global={true}
                countries={true}
                states={true}
                cities={false}
            />
            <Switch>
                <Route exact path="/" component={Login} />
                <PrivateRoute
                    exact
                    path="/change_password"
                    component={ChangePassword}
                />
                <PrivateRoute exact path="/profile" component={Profile} />
                <PrivateRoute exact path="/dashboard" component={Dashboard} />
                <PrivateRoute
                    exact
                    path="/auction/:action"
                    component={AuctionLots}
                />
                <PrivateRoute exact path="/payment" component={Payment} />
                <PrivateRoute exact path="/wallet" component={Wallet} />
                <PrivateRoute exact path="/report" component={Report} />
                <PrivateRoute
                    exact
                    path="/listing/:action"
                    component={Listing}
                />
                <PrivateRoute
                    exact
                    path="/agency/:action"
                    component={AgencyView}
                />
                <PrivateRoute
                    exact
                    path="/agency/users/all"
                    component={AllAgencyUsers}
                />
                <PrivateRoute
                    exact
                    path="/agency/payment"
                    component={AgencyPayment}
                />
                <PrivateRoute
                    exact
                    path="/templates/auction"
                    component={AuctionTemplates}
                />
                <PrivateRoute
                    exact
                    path="/templates/listing"
                    component={ProductTemplates}
                />
                <PrivateRoute
                    exact
                    path="/users/:action"
                    component={UserView}
                />
                <PrivateRoute
                    exact
                    path="/employees/:action"
                    component={Employee}
                />
                <PrivateRoute
                    exact
                    path="/sellers/:action"
                    component={EmployeeSeller}
                />
                <PrivateRoute exact path="/logs/:action" component={Logs} />
                <PrivateRoute
                    exact
                    path="/communications/:action"
                    component={TemplateView}
                />
                <PrivateRoute
                    exact
                    path="/languageManager"
                    component={LanguageManager}
                />
                <PrivateRoute exact path="/store/themes" component={Theme} />
                <PrivateRoute
                    exact
                    path="/store/configuration"
                    component={Theme}
                />
                <PrivateRoute
                    exact
                    path="/invoice/:action"
                    component={Invoice}
                />
                <PrivateRoute
                    exact
                    path="/review/:action"
                    component={UserReview}
                />
                <PrivateRoute
                    exact
                    path="/billing/:action"
                    component={MyInvoice}
                />
                <PrivateRoute
                    exact
                    path="/ordercontrol/:action"
                    component={Order}
                />
                <PrivateRoute
                    exact
                    path="/settings/static"
                    component={StaticView}
                />
                <PrivateRoute
                    exact
                    path="/settings/general"
                    component={ConfigView}
                />
                <PrivateRoute
                    exact
                    path="/settings/maintanence"
                    component={MaintanenceManage}
                />
                <PrivateRoute
                    exact
                    path="/settings/category"
                    component={CategorySelect}
                />
                <PrivateRoute
                    exact
                    path="/settings/condition"
                    component={Condition}
                />
                <PrivateRoute
                    exact
                    path="/settings/category"
                    component={Category}
                />
                <PrivateRoute exact path="/erp" component={ERP} />
                <PrivateRoute
                    exact
                    path="/settings/location"
                    component={Location}
                />
                <PrivateRoute exact path="/return/:action" component={Return} />
                <PrivateRoute
                    exact
                    path="/settings/bid_increments"
                    component={BidIncrement}
                />
                <PrivateRoute
                    exact
                    path="/transaction/payment"
                    component={TransactionPayment}
                />
                <PrivateRoute
                    exact
                    path="/transaction/refund"
                    component={TransactionRefund}
                />
                <PrivateRoute exact path="/org/:action" component={OrgView} />
                <PrivateRoute
                    exact
                    path="/campaign/create"
                    component={CreateCampaign}
                />
                <PrivateRoute
                    exact
                    path="/campaign/template"
                    component={EmailTemplate}
                />
                <PrivateRoute exact path="/messages" component={Message} />
                <PrivateRoute
                    exact
                    path="/inventory/:action"
                    component={Inventory}
                />
                <PrivateRoute
                    exact
                    path="/bid_deposit"
                    component={BidDeposit}
                />
                <PrivateRoute
                    exact
                    path="/videoAuction/broadcast"
                    component={BroadCaster}
                />
                <PrivateRoute
                    exact
                    path="/billing/:type/:id"
                    component={BillingInfo}
                />
                {/* <PrivateRoute
                    exact
                    path="/payments/saved_cards"
                    component={MyCard}
                /> */}
                <PrivateRoute
                    exact
                    path="/videoAuction/live_auction"
                    component={LiveAuction}
                />
                <PrivateRoute
                    exact
                    path="/ui_settings"
                    component={SettingsUI}
                />
                <PrivateRoute
                    exact
                    path="/dynamic/pages"
                    component={DynamicPage}
                />
                <PrivateRoute
                    exact
                    path="/activity"
                    component={CustomerActivity}
                />

                <PrivateRoute
                    exact
                    path="/dynamic/table/pages"
                    component={DynamicTablePages}
                />
                <PrivateRoute
                    exact
                    path="/appointment/:action"
                    component={Appointment}
                />
                <PrivateRoute
                    exact
                    path="/erp/auction/:action"
                    component={ERP}
                />
                <PrivateRoute exact path="/erp/:id" component={ERP} />
                <PrivateRoute
                    exact
                    path="/subscribers"
                    component={SubscribeData}
                />
                <PrivateRoute
                    exact
                    path="/settings/tax_code"
                    component={TaxCodeList}
                />
                <PrivateRoute
                    exact
                    path="/settings/palletPricing"
                    component={PalletPricing}
                />
                <PrivateRoute exact path="/plugins" component={Plugins} />
                <PrivateRoute
                    exact
                    path="/settings/banner"
                    component={BannerImage}
                />
                <PrivateRoute
                    exact
                    path="/settings/twoFactor"
                    component={TwoFactor}
                />
                <PrivateRoute
                    exact
                    path="/questions_answers"
                    component={QuestionAnswer}
                />
                <PrivateRoute
                    exact
                    path="/listing/edit/:id"
                    component={EditListing}
                />
                <PrivateRoute
                    exact
                    path="/listing/:status/:id"
                    component={ListingManage}
                />
                <PrivateRoute
                    exact
                    path="/auction/:status/:id"
                    component={AuctionListing}
                />
                <PrivateRoute
                    exact
                    path="/invoice/view/:id/:uid"
                    component={InvoiceView}
                />
                <PrivateRoute
                    exact
                    path="/employees/edit/:eid"
                    component={EmployeeEdit}
                />
                <PrivateRoute
                    exact
                    path="/sellers/edit/:eid"
                    component={SellerEdit}
                />
                <PrivateRoute
                    exact
                    path="/templates/listing/:status/:id"
                    component={ProductTemplateManage}
                />
                <PrivateRoute
                    exact
                    path="/templates/auction/:status/:id"
                    component={AuctionTemplateManage}
                />
                <PrivateRoute
                    exact
                    path="/questions_answers/:id/:productId"
                    component={ManageComments}
                />
                <PrivateRoute
                    exact
                    path="/employees/new/:eid"
                    component={EmployeeManage}
                />
                <PrivateRoute
                    exact
                    path="/sellers/new/:eid"
                    component={EmployeeSellerManage}
                />
                <PrivateRoute
                    exact
                    path="/return/view/:id/:uid"
                    component={ReturnView}
                />
                <PrivateRoute
                    exact
                    path="/seller/:status/:id"
                    component={OrgManage}
                />
                <PrivateRoute
                    exact
                    path="/user/:status/:id"
                    component={UserManage}
                />
            </Switch>
        </>
    )
}
export default withRouter(Routes)
